import styled, { css, keyframes } from 'styled-components';

import { BRAND_COLORS } from './colors';

const spin = keyframes`
  from {
    rotate: 0deg;
  }
  to {
    rotate: 360deg;
  }
`;

interface LoadingSpinnerProps {
  size?: number;
  color?: string;
}

export const createLoadingSpinner = ({ size = 20, color = BRAND_COLORS.darkGreen }: LoadingSpinnerProps) => css`
  width: ${size}px;
  height: ${size}px;
  border-radius: 50%;
  border: 2px solid ${color};
  border-top-color: transparent;
  animation: ${spin} 1s linear infinite;
`;

export const LoadingSpinner = styled.div<LoadingSpinnerProps>`
  align-self: center;
  ${createLoadingSpinner}
`;
